<template>
  <v-progress-linear
    :indeterminate="true" color="red lighten-1"
    class="page-bottom-progress"
  ></v-progress-linear>
</template>

<script>
export default {
  name: 'mv-page-bottom-progress'
}
</script>

<style lang="css">
.page-bottom-progress {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
  margin: 0;
  z-index: 5;
}
</style>
